import { useLocation } from '@tanstack/react-router';
import { Dispatch, SetStateAction, useState } from 'react';
import { SortOrder } from 'src/types/enum/sort-order';
import { SortController } from 'src/types/interfaces/sort-controller';

interface Params {
  sortOrder?: SortOrder;
  sortBy?: string;
}

export type SetSortController = Dispatch<SetStateAction<SortController>>;

type ReturnType = [SortController, SetSortController];

export const useSortController = ({
  sortOrder = SortOrder.DESC,
  sortBy = 'from',
}: Params = {}): ReturnType => {
  const location = useLocation();

  const [urlSortBy, urlSortOrder] =
    location.search?.sort && location.search.sort.length > 0
      ? location.search.sort[0].split(':')
      : [undefined, undefined];

  const isCorrectSortOrder = (sortOrder: string): sortOrder is SortOrder =>
    sortOrder === SortOrder.ASC || sortOrder === SortOrder.DESC;

  const [sortController, setSortController] = useState<SortController>(() => ({
    sortOrder:
      urlSortOrder && isCorrectSortOrder(urlSortOrder)
        ? urlSortOrder
        : sortOrder,
    sortBy: urlSortBy || sortBy,
  }));

  return [sortController, setSortController];
};
